<app-loader></app-loader>
<p-toast key="notification" position="top-center"></p-toast>
<router-outlet></router-outlet>

